import { createFileRoute } from "@tanstack/react-router";
import { StatesList } from "@/components/Map/components/StatesList";

export const Route = createFileRoute("/_auth/kart/assetGroup/$assetGroupName/states")({
  component: () => <StatesList mode="assetGroup" />,
});
